<view-charges
  headerFieldKey="LABELS.ADDITIONAL_CHARGES"
  totalFieldKey="LABELS.TOTAL_PAYMENT"
  [bills]="additionalCharges"
  [showCategories]="false"
  *ngIf="additionalCharges?.items?.length"
></view-charges>

<view-charges
  headerFieldKey="LABELS.SHIPMENT_CHARGES"
  [bills]="nonPayedBills"
  *ngIf="!additionalCharges?.items?.length && !alreadyPayedBills?.items?.length"
></view-charges>

<view-charges
  headerFieldKey="LABELS.SHIPMENT_CHARGES"
  [bills]="alreadyPayedBills"
  [isPayed]="true"
  *ngIf="alreadyPayedBills?.items?.length && !nonPayedBills?.items?.length"
></view-charges>

<div class="total-wrapper">
  <h3>{{ "LABELS.TOTAL_SHIPMENT_CHARGES" | translate }}:</h3>
  <strong>{{ totalCharges | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</strong>
</div>
